// Noodle & Snoot: Shipping progress bar. Added 10 September 2026,
// replacing the plain-text Dynamic Shipping Notice (still present in
// assets/ns-shipping-notice.js, disabled but not removed, see
// Protected Custom Code Registry item 4). Same thresholds and
// behaviour as the original: $100 AUD domestic free-shipping cutoff,
// Express postage tiered by cart weight (not shown in the bar itself,
// kept out of the label to stay quiet), $200 AUD-equivalent threshold
// for other currencies via Shopify's live conversion rate.
//
// Renders into any of three possible container ids that may exist on
// a given page: ns-shipping-bar-cart (cart page), ns-shipping-bar-notification
// (add-to-cart popup), ns-shipping-bar-product (product page). Missing
// containers are skipped, so one script safely serves all three
// placements without needing to know which page it's on. Each
// container is expected to hold a .ns-shipping-progress__label and a
// .ns-shipping-progress__track > .ns-shipping-progress__fill.

function renderShippingProgress() {
  var containerIds = ['ns-shipping-bar-cart', 'ns-shipping-bar-notification', 'ns-shipping-bar-product'];
  var targets = containerIds
    .map(function (id) {
      return document.getElementById(id);
    })
    .filter(function (el) {
      return el;
    });

  if (targets.length === 0) return;

  fetch('/cart.js')
    .then(function (response) {
      if (!response.ok) throw new Error('Cart data fetch failed');
      return response.json();
    })
    .then(function (cart) {
      var totalPriceLocal = cart.total_price / 100;
      var currency = cart.currency;

      var threshold, percent, unlocked, label;

      if (currency === 'AUD') {
        threshold = 100;
        unlocked = totalPriceLocal >= threshold;
        percent = Math.min(100, (totalPriceLocal / threshold) * 100);
        if (unlocked) {
          label = "You've unlocked free Express Shipping (AU)";
        } else {
          var gap = (threshold - totalPriceLocal).toFixed(2);
          label = 'Spend $' + gap + ' more for free Express Shipping (AU)';
        }
      } else {
        var conversionRate =
          window.Shopify && window.Shopify.currency && window.Shopify.currency.rate
            ? parseFloat(window.Shopify.currency.rate)
            : 1;
        threshold = 200 * conversionRate;
        unlocked = totalPriceLocal >= threshold;
        percent = Math.min(100, (totalPriceLocal / threshold) * 100);
        if (unlocked) {
          label = "You've unlocked free international shipping";
        } else {
          var intGap = (threshold - totalPriceLocal).toFixed(2);
          var formattedGap = parseFloat(intGap).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
          label = 'Spend ' + currency + ' ' + formattedGap + ' more for free international shipping';
        }
      }

      targets.forEach(function (container) {
        if (cart.item_count === 0) {
          container.style.display = 'none';
          return;
        }
        container.style.display = '';

        var labelEl = container.querySelector('.ns-shipping-progress__label');
        var fillEl = container.querySelector('.ns-shipping-progress__fill');
        if (labelEl) labelEl.textContent = label;
        if (fillEl) fillEl.style.width = percent + '%';

        if (unlocked) {
          container.classList.add('ns-shipping-progress--unlocked');
        } else {
          container.classList.remove('ns-shipping-progress--unlocked');
        }
      });
    })
    .catch(function (err) {
      console.error('Shipping progress bar calculation error:', err);
    });
}

document.addEventListener('DOMContentLoaded', renderShippingProgress);

var nsProgressNativeFetch = window.fetch;
window.fetch = function () {
  var args = arguments;
  return nsProgressNativeFetch.apply(this, args).then(function (response) {
    var url = args[0];
    if (
      url &&
      typeof url === 'string' &&
      (url.indexOf('/cart/change') !== -1 ||
        url.indexOf('/cart/add') !== -1 ||
        url.indexOf('/cart/update') !== -1 ||
        url.indexOf('/cart/clear') !== -1)
    ) {
      setTimeout(renderShippingProgress, 100);
    }
    return response;
  });
};
